import React, {createContext} from 'react';
const PersonaContext = createContext(null);
export {PersonaContext};